import { HStack } from '@rbilabs/universal-components';

export const Container = HStack.withConfig<{ $containerHasTopPadding: boolean }>(props => ({
  paddingTop: props.$containerHasTopPadding ? '5' : '0',
}));
